import { render, staticRenderFns } from "./Activos.vue?vue&type=template&id=406dba23"
import script from "./Activos.vue?vue&type=script&lang=js"
export * from "./Activos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports